import { MatDialogRef } from '@angular/material/dialog';
import { getDirection } from '@cemex/cmx-client-layout';
import { select, Store } from '@ngrx/store';
import { Subject, Observable } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { GlobalFiltersState, Jobsite } from '../../models';
import { getAllJobsitesContent, getJobisteLoader, getJobsiteFilter } from '../../store/selectors';
import { SetJobsiteFilter } from '../../store/actions';
import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-select-jobsite-modal',
  templateUrl: './select-jobsite-modal.component.html',
  styleUrls: ['./select-jobsite-modal.component.scss'],
})
export class SelectJobsiteModalComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject();
  selected: number = null;
  filter: string;
  jobsites: Jobsite[] = [];
  overlayHeight = 'auto';
  loading = true;

  rtl$: Observable<boolean>;

  constructor(
    private dialogRef: MatDialogRef<SelectJobsiteModalComponent>,
    private store: Store<GlobalFiltersState>,
  ) {}

  get isSubmitDisabled(): boolean {
    return this.selected < 0 || this.selected === null;
  }

  ngOnInit() {
    this.store
      .pipe(
        select(getAllJobsitesContent),
        map((jobsites) => jobsites || []),
        takeUntil(this._destroyed$),
      )
      .subscribe((jobsites) => {
        if (jobsites.length > 6) {
          this.overlayHeight = '320px';
        }
        this.jobsites = jobsites;
      });
    this.store.pipe(select(getJobisteLoader), takeUntil(this._destroyed$)).subscribe((value) => (this.loading = value));

    this.rtl$ = this.store.pipe(
      select(getDirection),
      map((direction) => direction === 'rtl'),
    );

    this.store.pipe(select(getJobsiteFilter), takeUntil(this._destroyed$)).subscribe((value) => (this.filter = value));
  }

  onSearch(event: CustomEvent<string>) {
    if (!event) {
      return;
    }
    let searchString = event.detail;
    searchString = searchString && searchString.trim();
    if (this.filter === searchString) {
      return;
    }
    this.store.dispatch(new SetJobsiteFilter(searchString));
  }

  onSelect(event: CustomEvent) {
    if (!event || (event && !event.detail)) {
      return;
    }
    const id = Number(event.detail.value);
    if (id < 0) {
      return;
    }
    this.selected = id;
  }

  onSubmitClick() {
    const selectedJobsite = this.jobsites.find((jobsite) => jobsite.id === this.selected);
    this.dialogRef.close(selectedJobsite);
  }

  onCloseClick() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
